<template>
  <header class="header-global">
    <base-nav class="navbar-main navbar-dark bg-primary" type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <div>
          <img src="img/dkz/logo.webp" alt="logo">
        </div>
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand" v-if="connected_wallet === null">
          <base-button class="btn-1" type="warning" @click="connectWallet()">
            <span class="btn-inner--icon">
                  <i class="fa fa-link mr-2"></i>
                </span>
            <span class="nav-link-inner--text">Connect</span>
          </base-button>
        </div>

        <div class="col-6 collapse-brand" v-if="connected_wallet !== null">

          <base-button class="btn-1" type="warning" @click="logout">
            <span class="btn-inner--icon">
                  <i class="fa fa-link mr-2"></i>
                </span>
            <span class="nav-link-inner--text">{{ connected_wallet !== null ? truncatedAddress : 'Connect wallet' }} | Logout</span>
          </base-button>


        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <div class="main-text-header">
        DogeKongZilla Token Dashboard
      </div>

      <ul class="navbar-nav align-items-lg-center ml-lg-auto">

        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="#" target="_blank" rel="noopener"
             data-toggle="tooltip" title="Follow us on Twitter">
            <i class="fa fa-twitter-square"></i>
            <span class="nav-link-inner--text d-lg-none">Twitter</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="#"
             target="_blank" rel="noopener" data-toggle="tooltip" title="Join with us">
            <i class="fa fa-telegram"></i>
            <span class="nav-link-inner--text d-lg-none">Telegram</span>
          </a>
        </li>

        <li class="nav-item d-none d-lg-block ml-lg-4" v-if="connected_wallet === null">
          <base-button class="btn-1" type="success" @click="connectWallet()">
            <span class="btn-inner--icon">
                  <i class="fa fa-link mr-2"></i>
                </span>
            <span class="nav-link-inner--text">Connect</span>
          </base-button>
        </li>

        <li class="nav-item d-none d-lg-block ml-lg-4" v-if="connected_wallet !== null">
          <base-button class="btn-1" type="success" @click="logout">
            <span class="btn-inner--icon">
              <i class="fa fa-link mr-2"></i>
            </span>
            <span class="nav-link-inner--text">{{ connected_wallet !== null ? truncatedAddress : 'Connect wallet' }} | Logout</span>
          </base-button>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import {mapGetters} from 'vuex'
import _ from 'lodash'

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  computed: {
    ...mapGetters([
      'connected_wallet'
    ]),
    truncatedAddress() {
      return _.truncate(this.connected_wallet || '', {
        length: 15
      })
    }
  },
  methods: {
    logout() {
      this.$root.$emit('logout')
    },
    connectWallet() {
      this.$root.$emit('connectWallet')
    }
  }
};
</script>
<style scoped>

.dkz-nav {
  background-color: black;
}

.main-text-header {
  color: white;
  font-size: 20px;
  font-weight: bold;
}

</style>
